import api from "@/api/axios/axios.js";

// --- Endpoints para el Manager (administra SU unidad; el back filtra por su profile) ---

/**
 * Presupuesto de la unidad del Manager.
 * GET /calculateApi/usage/unit-budget/
 * → { unidad_id, unidad_nombre, limite_usd, asignado, disponible, gastado }
 */
export const getUnitBudget = () =>
  api.get("/calculateApi/usage/unit-budget/").then((r) => r.data);

/**
 * Usuarios de SU unidad (el back filtra automáticamente).
 * GET /calculateApi/admin/users/
 * → [{ id, username, email, limit_usd, is_active, total_spent }]
 *   limit_usd = null → sin límite asignado (usuario bloqueado)
 */
export const getUnitUsers = () =>
  api.get("/calculateApi/admin/users/").then((r) => r.data);

/**
 * Asigna / re-establece el límite de un usuario de su unidad.
 * PATCH /calculateApi/admin/users/<id>/limit/  Body: { limit_usd, is_active }
 * → { user_id, username, limit_usd, is_active }
 * 400 si la suma excede el presupuesto → { error, limite_unidad, asignado_otros, disponible }
 * 403 si el usuario no es de su unidad → { error }
 */
export const setUserLimit = (userId, limitUsd, isActive = true) =>
  api
    .patch(`/calculateApi/admin/users/${userId}/limit/`, {
      limit_usd: limitUsd,
      is_active: isActive,
    })
    .then((r) => r.data);

/**
 * Reinicia el consumo de UN usuario (libera lo gastado, conserva su límite).
 * POST /calculateApi/admin/users/<id>/reset/
 * → { userID, username, filas_borradas, mensaje }
 */
export const resetUserUsage = (userId) =>
  api.post(`/calculateApi/admin/users/${userId}/reset/`).then((r) => r.data);

/**
 * Reinicia el consumo de TODA su unidad (todos sus usuarios). Conserva ConsumoMensual.
 * POST /calculateApi/admin/units/<unidadId>/reset/
 * → { unidad_id, unidad_nombre, filas_borradas, mensaje }
 * 403 si intenta reiniciar una unidad que no es la suya.
 */
export const resetUnitUsage = (unidadId) =>
  api.post(`/calculateApi/admin/units/${unidadId}/reset/`).then((r) => r.data);
